//09-5. 가상 코인 거래 기능 추가하며 마무리하기

/*
    Modal 공용 컴포넌트를 추가한 다음 모달에 포함될 화면 컴포넌트를 구성한다.
*/

//09-5-1. 모달 창으로 거래화면 만들기

/*
    모달 본문에 사용될 거래 화면은 구매, 판매용으로 총 2개가 필요하다.
*/

///09-5-1-2. 모달 공급자 컴포넌트 생성하기

import createProvider from '../doit-ui/Modal/create';
import { TRADE_COIN_MODAL, REGISTER_USER_MODAL } from './constants/modals';
import TradeCoinPage from './containers/main/TradeCoinPageContainer';
import RegisterPage from './containers/signup/RegisterPageContainer';//11-5-7. 모달 본문 추가하기

export default createProvider({
    [TRADE_COIN_MODAL]: TradeCoinPage,
    [REGISTER_USER_MODAL]: RegisterPage,
});